(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["app-directory"] && !Shopify.designMode) return;
  try {
    
  (function () {
    'use strict';

    function initAppDirectory(dir) {
      if (dir.dataset.appDirInit === 'true') return;
      dir.dataset.appDirInit = 'true';

      var sectionId = dir.dataset.sectionId;

      function updatePageHeading(url) {
        var header = document.querySelector('h1');
        if (!header) return;

        var parsedUrl = new URL(url, window.location.origin);
        var pathParts = parsedUrl.pathname.split('/').filter(Boolean);

        // Example:
        // /collections/apps/shopify
        // ["collections", "apps", "shopify"]

        var tag = pathParts.length > 2 ? pathParts[pathParts.length - 1] : null;

        if (!tag) {
          header.innerText = 'All Apps';
          return;
        }

        var formattedTag = tag
          .split('-')
          .map(function (word) {
            return word.charAt(0).toUpperCase() + word.slice(1);
          })
          .join(' ');

        header.innerText = formattedTag + ' Apps';
      }

      /* Re-bound every time content is swapped in, since the search
         input itself is replaced along with the rest of dir's markup. */
      function bindSearch() {
        var grid = dir.querySelector('.app-dir__grid');
        var searchInput = dir.querySelector('.app-dir__search');
        var noResults = dir.querySelector('.app-dir__empty[data-no-results]');
        var searchTimer;

        function applySearch() {
          var q = (searchInput.value || '').trim().toLowerCase();
          var cards = grid.querySelectorAll('.app-card-host');
          var visible = 0;

          cards.forEach(function (card) {
            var title = card.dataset.title || '';
            var desc = card.dataset.desc || '';
            var matches = q === '' || title.indexOf(q) !== -1 || desc.indexOf(q) !== -1;

            if (matches) {
              card.removeAttribute('hidden');
              visible++;
            } else {
              card.setAttribute('hidden', '');
            }
          });

          if (noResults) {
            noResults.toggleAttribute('hidden', visible !== 0);
          }
        }

        if (searchInput) {
          searchInput.addEventListener('input', function () {
            clearTimeout(searchTimer);
            searchTimer = setTimeout(applySearch, 180);
          });
        }
      }

      /* ── AJAX pill navigation ─────────────────────────────── */

      function swapContent(html) {
        var doc = new DOMParser().parseFromString(html, 'text/html');
        var fresh = doc.querySelector('.app-dir[data-section-id="' + sectionId + '"]');
        if (!fresh) return false;
        dir.innerHTML = fresh.innerHTML;
        return true;
      }

      function navigate(url, pushHistory) {
        var fetchUrl = new URL(url, window.location.origin);
        fetchUrl.searchParams.set('section_id', sectionId);

        dir.setAttribute('aria-busy', 'true');
        dir.classList.add('app-dir--loading');

        fetch(fetchUrl.toString())
          .then(function (res) {
            if (!res.ok) throw new Error('Bad response');
            return res.text();
          })
          .then(function (html) {
            if (!swapContent(html)) {
              window.location.href = url;
              return;
            }
            if (pushHistory) {
              window.history.pushState({ appDirUrl: url }, '', url);
            }
            dir.removeAttribute('aria-busy');
            dir.classList.remove('app-dir--loading');
            /* Only rebind the bits that live inside the swapped markup —
               the click/popstate listeners below stay bound to the same
               dir/window for the life of the page, so they're set up once,
               outside this function, not re-added here. */
            bindSearch();

            updatePageHeading(url);

            dir.querySelector('.app-dir__pills')?.scrollIntoView({ block: 'nearest' });
          })
          .catch(function () {
            /* Any failure — real navigation, since pills are real links */
            window.location.href = url;
          });
      }

      /* Bound once, for the lifetime of the page — dir itself is never
         replaced, only its innerHTML, so these must not be re-added on swap. */
      dir.addEventListener('click', function (e) {
        var link = e.target.closest('.app-pill');
        if (!link) return;
        /* Let cmd/ctrl/middle-click open in a new tab as normal */
        if (e.metaKey || e.ctrlKey || e.shiftKey || e.button === 1) return;
        e.preventDefault();
        navigate(link.getAttribute('href'), true);
      });

      window.addEventListener('popstate', function () {
        navigate(window.location.href, false);
      });

      bindSearch();
    }

    function initAll() {
      document.querySelectorAll('.app-dir').forEach(initAppDirectory);
    }

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', initAll);
    } else {
      initAll();
    }

    /* Re-init when the theme editor injects/re-renders this section */
    document.addEventListener('shopify:section:load', function (event) {
      var dir = event.target.querySelector ? event.target.querySelector('.app-dir') : null;
      if (dir) initAppDirectory(dir);
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();
})();
